
interface HookHeartIconProps {
  size?: number;
  className?: string;
  color?:string,
}

export const HookHeartIcon: React.FC<HookHeartIconProps> = ({ size = 24,className = "",color="#fdfcfc"}) => {


  return (
     <svg
      width={size}
      height={size}
      viewBox="0 0 98 87"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
        <path d="M24.9,1.4c9.8,0 18.7,6.3 22.3,15.5l1.8,4.7l1.8,-4.7c3.6,-9.3 12.5,-15.5 22.3,-15.5c13.2,0 23.9,10.8 23.9,24.1c-0,6 -2.6,12.8 -7.5,20.4c-4.1,6.2 -9.7,12.8 -16.8,19.7c-10.1,9.8 -20.3,17.4 -23.6,19.7c-3.3,-2.3 -13.5,-9.9 -23.6,-19.7c-7.1,-6.9 -12.8,-13.6 -16.9,-19.7c-5,-7.6 -7.5,-14.4 -7.5,-20.5c0,-13.3 10.7,-24.1 23.9,-24.1Z"  fill={color} opacity={color === "#fdfcfc" ? 0.4 : 1}/>
        <path d="M49,87l-1,-0.7c-0.1,-0.1 -12.1,-8.2 -23.8,-19.5c-6.9,-6.7 -12.5,-13.1 -16.5,-19.2c-5.1,-7.7 -7.7,-14.9 -7.7,-21.3c0,-14.5 11.8,-26.3 26.2,-26.3c5.4,0 10.6,1.7 15,4.8c3.2,2.3 5.8,5.2 7.8,8.5c1.9,-3.4 4.5,-6.3 7.8,-8.5c4.4,-3.1 9.6,-4.8 15,-4.8c14.5,0 26.2,11.8 26.2,26.3l0,0c-0.1,6.3 -2.7,13.4 -7.8,21.1c-4,6.1 -9.5,12.5 -16.5,19.2c-11.7,11.3 -23.6,19.5 -23.7,19.6l-1,0.7Zm-22.8,-83.3c-12.4,0 -22.6,10.2 -22.6,22.6c0,5.6 2.4,12.1 7.1,19.2c3.8,5.8 9.2,12.1 15.9,18.5c9.5,9.2 19.2,16.3 22.3,18.5c3.1,-2.2 12.7,-9.3 22.3,-18.5c6.7,-6.5 12.1,-12.7 15.9,-18.5c4.7,-7.1 7.1,-13.5 7.1,-19.1c0,-12.5 -10.1,-22.6 -22.6,-22.6c-9.2,0 -17.7,5.8 -21.1,14.6l-1.7,4.4l-1.7,-4.4c-3.4,-8.7 -11.8,-14.6 -21,-14.6Z" fill={color}/>
    </svg>
  );
};
